// extracted by mini-css-extract-plugin
export default {"inputs":"auth_inputs__sppmU","LoginButton":"auth_LoginButton__odInU","Iconcenter":"auth_Iconcenter__2hGXI"};